"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderLine = void 0;
const common_1 = require("../../common");
const models_1 = require("../../products/models");
const enums_1 = require("../enums");
const sales_order_header_model_1 = require("./sales-order-header.model");
const sales_order_release_model_1 = require("./sales-order-release.model");
const sales_order_revise_alteration_model_1 = require("./sales-order-revise-alteration.model");
class SalesOrderLine extends common_1.MongoDocument {
    get quantity() {
        return this.releases
            .map(release => (typeof release === 'string' ? undefined : release.quantity))
            .reduce((total, num) => (num !== undefined && total !== undefined ? total + num : undefined), 0);
    }
    get qtyOpen() {
        return this.releases
            .map(release => (typeof release === 'string' ? undefined : release.quantity - release.shipped))
            .reduce((total, num) => (num !== undefined && total !== undefined ? total + num : undefined), 0);
    }
    get total() {
        if (this.quantity)
            return this.price * this.quantity;
        else
            return undefined;
    }
}
exports.SalesOrderLine = SalesOrderLine;
//# sourceMappingURL=sales-order-line.model.js.map